module.exports = __webpack_public_path__ + "static/media/article-icon-active.e6c96213.svg";